import React from 'react'
import ButtonBasic from "./ButtonBasic";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTrashAlt } from '@fortawesome/free-solid-svg-icons';

const ButtonDelete = ({ label, cypressid, style: userStyles = {}, ...props }) => {

    return (
        <ButtonBasic
            label={label}
            style={userStyles}
            id="danger"
            cypressid={cypressid}
            {...props}
        ><FontAwesomeIcon className="font-icon" icon={faTrashAlt} /></ButtonBasic>
    )
}

ButtonDelete.defaultProps = {
    label: "Delete",
    cypressid: "delete"
}

export default ButtonDelete;